import { useCallback, useEffect, useState } from "preact/hooks";
import axios from "axios";

export default function useKeys(target) {
    const [token, setToken] = useState();
    
    const [tokenLoading, setIsTokenLoading] = useState(false);

    const fetchToken = useCallback(async () => {
        setIsTokenLoading(true);
        try {
            const response = await axios.get("/user/resources/access-tokens?permanent=true");

            if (Array.isArray(response.data) && response.data.length === 0) {
                const newTokenResponse = await axios.post("/user/resources/access-token/permanent");
                setToken(newTokenResponse.data);
            } else {
                setToken(response.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsTokenLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchToken();
    }, []);

    return { token, fetchToken, tokenLoading};
}